export default "__VITE_ASSET__Cd$K9y$w__"